export default __webpack_public_path__ + "static/media/Chipley1.1770b815.png";